import { useEffect, useRef } from 'react';
export const useProgressFailed = (isInProgress, hasErrors, onFailed)=>{
    const prevIsInProgressRef = useRef(isInProgress);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && hasErrors) {
                onFailed();
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
};
